
import { showOpenApp } from '@/tools/AppConfig'
import copy from 'copy-to-clipboard'
import { regMobileDevice } from '@/tools/constant'

const openInAppMixin = {
  data: function () {
    return {
      showOpenApp: showOpenApp && (navigator.userAgent && navigator.userAgent.match(regMobileDevice))
    }
  },
  methods: {
    openInApp (url) {
    //   if (/(Android)/i.test(navigator.userAgent)) {
    //     // eslint-disable-next-line
    //     new OpenInstall({
    //       appKey: 'hzra49',
    //       preferWakeup: true,
    //       onready: function () {
    //         var m = this
    //         m.wakeupOrInstall()
    //       }
    //     }, { url })
    //   } else {
    //     window.open('/static/app.html?url=' + url, '_blank')
    //   }
      if (url) {
        copy('gc://' + url)
      }
      // eslint-disable-next-line
      new window.OpenInstall({
        appKey: 'hzra49',
        preferWakeup: true,
        onready: function () {
          var m = this
          m.wakeupOrInstall()
        }
      }, { url })
    }
  }
}

export default openInAppMixin
